import axios, { AxiosInstance } from 'axios';

import { apiRequestTimeout, currentBrand, fesApiBaseUrl, integrationApiBaseUrl } from '../config';

export const CpDataApi: AxiosInstance = axios.create({
    baseURL: integrationApiBaseUrl,
    timeout: apiRequestTimeout,
});

// In development the request goes through the dev-server proxy (see src/setupProxy.js)
// because the FES API does not send CORS headers for http://localhost:3000.
export const CpContentIntegrationApi = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? '/' : fesApiBaseUrl,
});

export const CpContentApi: AxiosInstance = axios.create({
    baseURL: '/contents',
    headers: {
        'X-CP-Brand': currentBrand,
    },
});
